/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ view: NonNullable<unknown> }} Ui_Map_View_Pill_LabelInputs */

const en_ui_map_view_pill_label = /** @type {(inputs: Ui_Map_View_Pill_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Map view: ${i?.view}`)
};

const de_ui_map_view_pill_label = /** @type {(inputs: Ui_Map_View_Pill_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kartenansicht: ${i?.view}`)
};

/**
* | output |
* | --- |
* | "Map view: {view}" |
*
* @param {Ui_Map_View_Pill_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_map_view_pill_label = /** @type {((inputs: Ui_Map_View_Pill_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Map_View_Pill_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_map_view_pill_label(inputs)
	return de_ui_map_view_pill_label(inputs)
});